module.exports = __webpack_public_path__ + "img/5-1_03.490dcbf8.jpg";